import api from '@/api/services/api'

const getHotel = id => api({
  method: 'get',
  url: `hotels/${id}`,
})

const getActualize = params => api({
  method: 'get',
  url: '/cart/actualize',
  params
})

const getHotelsAccommodations = params => api({
  method: 'get',
  url: '/accommodations/search',
  params
})

const getHotelTariffConditions = params => api({
  method: 'get',
  url: '/accommodations/info',
  params
})

const getHotelsPenalties = params => api({
  method: 'get',
  url: '/accommodations/penalties',
  params
})

const booking = data => api({
  method: 'post',
  url: '/cart/booking',
  data
})


export {
  getHotel,
  getActualize,
  getHotelsAccommodations,
  getHotelTariffConditions,
  getHotelsPenalties,
  booking
}